import React, { useEffect, useState } from 'react';
import API from '../services/api';

function AdminDebtRecordsPage() {
  const [debtRecords, setDebtRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingRecordId, setEditingRecordId] = useState(null);
  const [followUpNotes, setFollowUpNotes] = useState('');

  const fetchDebtRecords = async () => {
    try {
      setLoading(true);
      // We expect each row to have { id, client_name, therapist_first_name, billed_amount, etc. }
      const res = await API.get('/admin/debt-records');
      setDebtRecords(res.data);
    } catch (err) {
      console.error(err);
      alert('Error fetching debt records');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (recordId, newStatus) => {
    try {
      // Send the updated status & notes to PUT /admin/debt-records/:id
      await API.put(`/admin/debt-records/${recordId}`, {
        status: newStatus,
        notes: followUpNotes,
      });
      alert('Debt record updated');
      setEditingRecordId(null);
      setFollowUpNotes('');
      fetchDebtRecords(); // reload updated data
    } catch (err) {
      console.error(err);
      alert('Error updating debt record');
    }
  };

  useEffect(() => {
    fetchDebtRecords();
  }, []);

  return (
    <div style={{ margin: '2rem' }}>
      <h2>Debt Records Management</h2>

      {loading && <p>Loading...</p>}

      {!loading && debtRecords.length === 0 && <p>No unpaid debt records found.</p>}

      {!loading && debtRecords.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Client</th>
              <th>Therapist</th>
              <th>Billed</th>
              <th>Collected</th>
              <th>Owed</th>
              <th>Session Date</th>
              <th>Status</th>
              <th>Notes</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {debtRecords.map((record) => {
              // We assume the server returned record.billed_amount, record.collected_amount, record.status, record.notes, etc.
              const billedAmount = parseFloat(record.billed_amount) || 0;
              const collectedAmount = parseFloat(record.collected_amount) || 0;
              const owed = billedAmount - collectedAmount;
              const isEditing = editingRecordId === record.id;

              return (
                <tr key={record.id}>
                  <td>{record.client_name}</td>
                  <td>
                    {record.therapist_first_name} {record.therapist_last_name}
                  </td>
                  <td>${billedAmount.toFixed(2)}</td>
                  <td>${collectedAmount.toFixed(2)}</td>
                  <td>${owed.toFixed(2)}</td>
                  <td>{new Date(record.session_date).toLocaleDateString()}</td>
                  <td>{record.status}</td>
                  <td>
                    {isEditing ? (
                      <textarea
                        rows="3"
                        value={followUpNotes}
                        onChange={(e) => setFollowUpNotes(e.target.value)}
                      />
                    ) : (
                      <span>{record.notes || 'No notes'}</span>
                    )}
                  </td>
                  <td>
                    {isEditing ? (
                      <>
                        <button onClick={() => handleUpdate(record.id, record.status)}>
                          Save Notes
                        </button>
                        <button onClick={() => setEditingRecordId(null)}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => {
                            setEditingRecordId(record.id);
                            setFollowUpNotes(record.notes || '');
                          }}
                        >
                          Add Notes
                        </button>
                        {/* Updated button to mark SUBMITTED instead of PAID */}
                        <button onClick={() => handleUpdate(record.id, 'SUBMITTED')}>
                          Mark as Submitted
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AdminDebtRecordsPage;
